<template>
    <Modal :show="showConfirmModal" @close="showConfirmModal = false" :custom_modal_class="'modal-xs fullwidth-modal'">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('account_confirmation.confirmation_title') }}</h5>
                <button type="button" class="close" @click="showConfirmModal = false" aria-label="Close"><span aria-hidden="true">×</span></button>
            </div>
        </div>

        <div slot="body">
            <p>{{ confirmText }}</p>

            <div class="alert alert-danger" v-if="errorMessage">
                {{ errorMessage }}
            </div>

            <ValidationObserver ref="formRef" v-slot="{handleSubmit}">
                <form @submit.prevent="handleSubmit(submitForm)" id="confirmForm">
                    <ValidationProvider name="password" rules="required" v-slot="{ errors }" class="flex-grow-1">
                        <div class="form-group">
                            <label for="input-password" class="form-control-label">{{ $t('account_confirmation.password') }}</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <icon name="key"></icon>
                                    </span>
                                </div>
                                <input
                                    v-model="data.password"
                                    :type="passwordVisible ? 'text' : 'password'"
                                    class="form-control"
                                    id="input-password"
                                    :placeholder="$t('account_confirmation.fill_in_password')"
                                    :class="{ 'is-invalid': errors.length }"
                                    required
                                />
                                <div class="input-group-append">
                                <span class="input-group-text" @click="passwordVisible = !passwordVisible" style="cursor: pointer;">
                                    <icon :name="passwordVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                                </div>
                                <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </div>
                    </ValidationProvider>
                </form>
            </ValidationObserver>
        </div>

        <div slot="footer" class="w-100">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="showConfirmModal = false">{{ $t('general.close') }}</button>
            <button type="submit" form="confirmForm" class="btn btn-primary btn-sm float-right" data-dismiss="modal">{{ $t('account_confirmation.confirm') }}</button>
        </div>
    </Modal>
</template>
<script setup>
    import Modal from '../components/Modal.vue';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { ref, watch } from 'vue';
    import { notifyError } from '../utils/notify';
    import { AccountService } from '../services/accountService';
    import i18n from '../utils/locale';

    const emit = defineEmits(['close', 'confirmed']);

    defineProps({
        errorMessage: {
            type: String,
            default: null,
        },

        confirmText: {
            type: String,
            default(){
                return i18n.t('account_confirmation.confirmation_description')
            }
        }
    });

    const formRef = ref(null);
    const showConfirmModal = ref(true);
    const passwordVisible = ref(false);
    const data = ref({
        password: null,
    });

    watch(() => showConfirmModal.value, () => {
        emit('close');
    });

    async function submitForm() {
        try {
            const token = await AccountService.getInstance().getConfirmationToken(data.value);

            emit('confirmed', token);
        } catch (exception) {
            formRef.value.setErrors({
                password: exception?.response?.data?.errors?.password || i18n.t('general.something_went_wrong'),
            });

            notifyError(exception);
        }
    }
</script>
